import React from "react";
import { Form, Col } from "react-bootstrap";
import CustomReactSelect from "../../../components/CustomReactSelect";
import FilterationBarContainer from "../../../components/FilterationBarContainer";

function FilterationBar(props) {
  const { years, selectedYear, onYearChange } = props;
  return (
    <FilterationBarContainer>
      <Col lg={4}>
        <Form.Group className="input-field">
          <Form.Label className="label">Year</Form.Label>
          <Col>
            <CustomReactSelect
              options={years}
              value={selectedYear}
              onChange={(value) => onYearChange(value)}
            />
          </Col>
        </Form.Group>
      </Col>
    </FilterationBarContainer>
  );
}

export default FilterationBar;
